<script>
import { mapState, mapActions } from 'vuex';
import store from '../../../store';

export default {
  components: {
  },
  data() {
    return {
      headers: [
        { text: '', sortable: false, width: '10%' },
        { text: 'Title', sortable: false, width: '35%' },
        { text: 'Description', sortable: false, width: '45%' },
        { text: '', sortable: false, width: '10%' },
      ],
      textRule: [v => !!v || 'Text cannot be empty'],
      clonedPickupPlaces: [],
      pickupPlacesValid: false,
    };
  },
  computed: {
    ...mapState({
      pickupPlaces: state => state.areas.pickupPlaces.items,
      loading: state => state.areas.pickupPlaces.loading,
      error: state => state.areas.pickupPlaces.error,
      area: state => state.areas.area,
    }),
  },
  methods: {
    ...mapActions({
      fetchPickupPlaces: 'areas/fetchPickupPlaces',
      updatePickupPlaces: 'areas/updatePickupPlaces',
    }),
    createNewPickupPlace() {
      this.clonedPickupPlaces.unshift({
        id: null,
        areaId: this.area.id,
        title: '',
        description: '',
      });
    },
    save() {
      if (this.$refs.pickupPlacesForm.validate()) {
        this.updatePickupPlaces(this.clonedPickupPlaces);
      }
    },
  },
  mounted() {
    this.clonedPickupPlaces = [...this.pickupPlaces];
  },
  watch: {
    pickupPlaces() {
      this.clonedPickupPlaces = [...this.pickupPlaces];
    },
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('areas/fetchPickupPlaces', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next();
      });
  },
};
</script>

<template>
  <v-flex class="ski-area-pickup-places">
    <v-flex>
      <v-btn
        @click="save"
        :disabled="!pickupPlacesValid"
        color="green"
        flat
      >
        Save
      </v-btn>
      <v-btn
        @click="createNewPickupPlace"
        color="blue darken-1"
        flat
      >
        Add new pickup place
      </v-btn>
    </v-flex>
    <v-flex>
      <v-form
        ref="pickupPlacesForm"
        v-model="pickupPlacesValid"
        lazy-validation>
        <v-data-table
          :items="clonedPickupPlaces"
          :loading="loading"
          :error="error"
          :headers="headers"
          class="print"
          hide-actions
        >
          <template v-slot:items="data">
            <template>
              <td v-if="data.item.id">
              </td>
              <td v-else class="">
                {{ 'NEW' }}
              </td>
            </template>
            <td>
              <v-text-field
                v-model="clonedPickupPlaces[data.index].title"
                :rules="textRule"
              >
              </v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="clonedPickupPlaces[data.index].description"
                :rules="textRule"
              >
              </v-text-field>
            </td>
            <td>
              <v-btn
                v-if="!data.item.id"
                @click="clonedPickupPlaces.splice(data.index, 1)"
                color="red darken-1"
                flat
              >
                Delete
              </v-btn>
            </td>
          </template>
          <template slot="no-data">
            <div v-if="error">
              <v-alert value="Something went wrong. Try again." icon="warning"/>
            </div>
          </template>
        </v-data-table>
      </v-form>
    </v-flex>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/pages/ski/areas/SkiAreaPickupPlaces.vue